package com.karyadina.service

import kotlinx.coroutines.flow.MutableStateFlow

actual fun provideModelManager(): ModelManagementService {
    return object : ModelManagementService {
        override val modelStatus = MutableStateFlow(ModelStatus.MISSING)
        override fun downloadModel() {
            println("Model download not supported on Web")
        }
        override fun deleteModel() {}
        override fun checkStatus() {}
        override suspend fun importModel(uriStr: String): Boolean = false
    }
}
